
import { defineComponent } from 'vue';
import DocContent from './DocContent.vue';
import { DocFull, getDoc, lastSeenVersion, markSeen } from '../../docsHelp';

/**
 * Slide-up help panel shown over the current screen, so anything typed in a form underneath
 * is kept while the user reads.
 */
export default defineComponent({
  name: 'HelpSheet',
  components: { DocContent },
  props: {
    open: { type: Boolean, default: false },
    slug: { type: String, default: null },
    anchor: { type: String, default: null },
  },
  emits: ['close', 'seen'],
  data() {
    return {
      doc: null as DocFull | null,
      loading: false,
      offline: false,
      updatedNote: null as string | null,
    };
  },
  watch: {
    open(value: boolean) {
      if (value) {
        this.load();
      }
    },
  },
  methods: {
    async load() {
      if (!this.slug) {
        return;
      }
      this.loading = true;
      const result = await getDoc(this.slug);
      this.doc = result.doc;
      this.offline = result.offline;
      this.loading = false;
      if (this.doc) {
        const seen = lastSeenVersion(this.doc.slug);
        this.updatedNote = seen > 0 && seen < this.doc.version ? this.doc.change_summary : null;
        markSeen(this.doc.slug, this.doc.version);
        this.$emit('seen');
      }
    },
  },
});
